export const API_FAIL = 'API_FAIL';
export const API_START = 'API_START';
export const STORE_LOCAL_DATA = 'STORE_LOCAL_DATA';
export const GET_LOCAL_DATA = 'GET_LOCAL_DATA';
export const REMOVE_LOCAL_DATA = 'REMOVE_LOCAL_DATA'
export const CLEAR_LOCAL_DATA = 'CLEAR_LOCAL_DATA'
export const CLEAR_ALL_DATA = 'CLEAR_ALL_DATA'
export const STORE_CACHE_DATA = 'STORE_CACHE_DATA';
export const GET_CACHE_DATA = 'GET_CACHE_DATA';
export const CLEAR_CACHE_DATA = 'CLEAR_CACHE_DATA';